import api from '../utils/api';
import { normalizeApiResponse } from '../utils/apiResponseHandler';

const tagService = {
  // Admin APIs - for managing tags within a dataroom
  async createTag(dataroomUuid, data) {
    try {
      const response = await api.post(`/datarooms/${dataroomUuid}/tags`, data);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  async getTags(dataroomUuid, params = {}) {
    try {
      const response = await api.get(`/datarooms/${dataroomUuid}/tags`, { params });
      return normalizeApiResponse(response, 'tags');
    } catch (error) {
      throw error;
    }
  },

  async getInvitationTags(dataroomUuid) {
    try {
      // API endpoint for getting only invitation tags for a dataroom
      const response = await api.get(`/datarooms/${dataroomUuid}/tags/list/invitation`);
      return normalizeApiResponse(response, 'tags');
    } catch (error) {
      throw error;
    }
  },

  async getTag(dataroomUuid, tagId) {
    try {
      const response = await api.get(`/datarooms/${dataroomUuid}/tags/${tagId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  async updateTag(dataroomUuid, tagId, data) {
    try {
      const response = await api.put(`/datarooms/${dataroomUuid}/tags/${tagId}`, data);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  async deleteTag(dataroomUuid, tagId) {
    try {
      const response = await api.delete(`/datarooms/${dataroomUuid}/tags/${tagId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Super Admin APIs - for managing all tags across the system
  async getAllTags(params = {}) {
    try {
      const response = await api.get('/admin/tags', { params });
      return normalizeApiResponse(response, 'tags');
    } catch (error) {
      throw error;
    }
  },

  async getSuperAdminTag(tagId) {
    try {
      const response = await api.get(`/admin/tags/${tagId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  async deleteSuperAdminTag(tagId) {
    try {
      const response = await api.delete(`/admin/tags/${tagId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Super Admin Dataroom Tags APIs - for managing tags within a specific dataroom
  async getSuperAdminDataroomTags(dataroomUuid, params = {}) {
    try {
      const response = await api.get(`/admin/datarooms/${dataroomUuid}/tags`, { params });
      
      // Return the response data directly as it already has the correct structure
      if (response.data && response.data.tags) {
        return response.data; // This returns { tags: [...], pagination: {...} }
      }
      
      return normalizeApiResponse(response, 'tags');
    } catch (error) {
      throw error;
    }
  },

  async createSuperAdminDataroomTag(dataroomUuid, data) {
    try {
      const response = await api.post(`/admin/datarooms/${dataroomUuid}/tags`, data);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  async getSuperAdminDataroomTag(dataroomUuid, tagId) {
    try {
      const response = await api.get(`/admin/datarooms/${dataroomUuid}/tags/${tagId}`);
      
      // Return the response data directly if it contains the tag
      if (response.data && response.data.tag) {
        return { data: response.data.tag };
      } else if (response.data && response.data.data) {
        return { data: response.data.data };
      } else if (response.data) {
        return { data: response.data };
      }
      
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  async updateSuperAdminDataroomTag(dataroomUuid, tagId, data) {
    try {
      const response = await api.put(`/admin/datarooms/${dataroomUuid}/tags/${tagId}`, data);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  async deleteSuperAdminDataroomTag(dataroomUuid, tagId) {
    try {
      const response = await api.delete(`/admin/datarooms/${dataroomUuid}/tags/${tagId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  }
};

export default tagService;